/*跳转壹心理app下载页*/
import axios from "axios";
import { getRequestSign } from 'lib/tools/platformSign'
import Clipboard from 'clipboard'

export default {
  mounted() {
    this.handleCopy()
  },
  data() {
    return {
      copyText: ''
    }
  },
  methods: {
    downloadApp () {
      // // 处理剪切板内容
      // let res = await this.handleCopy()
      // if (+res.code !== 0) {
      //   window.liveVue.$toast(res.message)
      //   return
      // }
      // 跳转下载页
      let isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
      // 如果是IOS，直接调起Apple Store
      if (isIOS) {
        window.location.href =
          'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
      } else {
        window.location.href = `https://m.xinli001.com/download`
      }
    },
    handleCommand() {
      let baseParams = {
        _platform: 'm',
        _version: '6.7.7',
        flag: 'weixin',
        type: 'live',
        object_id: this.$route.query.id,
        title: this.encodeCommand.title,
        desc: this.encodeCommand.desc || `${this.encodeCommand.channelName}的直播有趣好玩，快来围观！`,
        url: this.encodeCommand.url
      }
      let platFormSign = getRequestSign(baseParams)
      let newParams = Object.assign(platFormSign.params, {
        sign: platFormSign.sign
      })
      axios.get(window.$liveApi.yiapi_url + `/v6/yi/common/create-encode-command.json`, {
        params: newParams
      }).then(res => {
        if (+res.data.code === 0) {
          this.copyText = res.data.data
        } else {
          // this.$toast('生成口令失败')
        }
      })
    },
    handleCopy() {
      let clipboard = new Clipboard('.copyBtn', {
        text: () => {
          return this.copyText
        }
      });
      clipboard.on('success', () => {
        this.downloadApp()
      });
    }
  }
}
